module.exports = __webpack_public_path__ + "kudos_74.svg?2442163e7d538f64dfa6562d5d08cfa1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_74.svg
// module id = 177
// module chunks = 0